import types from '@/types';

const createAccessLogsModule = (accessLogService) => ({
  namespaced: true,
  state: {
    accessLogs: [],
    totalAccessLogs: 0,
    permissionTimeTypes: [
      { id: '', name: 'All' },
      { id: '1', name: 'Within the time' },
      { id: '2', name: 'Out of the time' },
      { id: '3', name: 'Not judged' },
    ],
    accessTypes: [
      { id: '', name: 'Todos' },
      { id: 'Entrada', name: 'Entrada' },
      { id: 'Salida', name: 'Salida' },
    ],
  },

  mutations: {
    [types.SET_ACCESS_LOGS](state, accessLogs) {
      state.accessLogs = accessLogs;
    },
    [types.SET_ACCESS_LOG](state, accessLog) {
      state.accessLog = accessLog;
    },
    SET_TOTAL_ACCESS_LOGS(state, totalAccessLogs) {
      state.totalAccessLogs = totalAccessLogs;
    },
  },

  actions: {
    [types.GET_ACCESS_LOGS]({ commit }, params) {
      return accessLogService.getList(params)
        .then((response) => {
          commit(types.SET_ACCESS_LOGS, response.data.results);
          commit('SET_TOTAL_ACCESS_LOGS', response.data.count);
        });
    },
    [types.GET_ACCESS_LOG]({ commit }, accessLogId) {
      return accessLogService.get(accessLogId)
        .then((response) => {
          commit(types.SET_ACCESS_LOG, response.data);
        });
    },
  },
});

export default createAccessLogsModule;



// WEBPACK FOOTER //
// ./src/store/modules/accessLogs.js